<template>
  <div id="mete-real" style="overflow:hidden;">
    <div class="meteReal-data" >
      <div class="meteReal-data-head">
        <div class="meteReal-head-left">
          <div class="meteReal-left-title">
            <span class="meteReal-left-title-container">气象实时数据</span>
          </div>
          <div class="meteReal-left-state" >
            <span class="meteReal-left-state-container" > 设备状态：{{meteDeviceSate}}</span>
          </div>
        </div>

        <div class="meteReal-head-right">
          <div class="meteReal-head-right-container">
            设备名
            <el-select @change="meteRealChange($event)" v-model="meteDevice" filterable >
              <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in meteOptionList" >
                <span :class="item.state === 'red' ? 'red-circle' : 'green-circle'"></span>
                {{ item.name }}
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
<!--      box-shadow: 0 2px 4px rgba(52, 99, 111, 0.5), 0 0 6px rgba(59, 130, 142, 0.5);-->
      <div class="meteReal-data-content" style="overflow:auto;" >
        <div v-for="(row,index) in sliceList(meteDataList, 5)" :key="index" style=" width: 100%;height: 20%;">
          <div class="meteReal-content-body">
            <div class="meteReal-content-bodyContainer"  v-for="(item,i) in row">
              <div class="meteReal-content-container">
                <div class="meteReal-content-containerTr">
                  <span class="meteReal-content-containerTd">{{item.ts}}</span>
                </div>
                <div class="meteReal-content-containerTr">
                  <span class="meteReal-content-containerTd">{{item.name}}</span>
                </div>
                <div class="meteReal-content-containerTr">
                  <span class="meteReal-content-containerTd">{{item.value}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

<!--        <table class="meteReal-content-table">-->
<!--          <tr v-for="(row,index) in sliceList(meteDataList, 5)" :key="index" >-->
<!--            <td v-for="(item, i) in row" :key="i" class="meteReal-table-td">-->
<!--              <div class="meteReal-content-div">-->
<!--                <span class="meteReal-content-ts">{{item.ts}}</span>-->
<!--              </div>-->
<!--              <div class="meteReal-content-div">-->
<!--                <span class="meteReal-content-name">{{item.name}}</span>-->
<!--              </div>-->
<!--              <div class="meteReal-content-div">-->
<!--                <span class="meteReal-content-value">{{item.value}}</span>-->
<!--              </div>-->
<!--            </td>-->
<!--          </tr>-->
<!--        </table>-->
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getDeviceValue
  } from "../../until/api/MeteSoil";
  import moment from 'moment';

  export default {
    name: 'MeteRealData',
    components:{},
    computed: {
      sliceList() {
        return function (data,count) {
          if(data != undefined) {
            let index = 0;
            let arrTemp = [];
            for(let i = 0; i < data.length; i++) {
              index = parseInt(i / count);
              if(arrTemp.length <= index) {
                arrTemp.push([])
              }
              arrTemp[index].push(data[i]);
            }
            return arrTemp;
          }
        }
      },

    },
    data() {
      return {
        meteOption: [],
        meteOptionList: [],
        meteDevice: '',
        meteDeviceJson: {},
        meteDataList:[],
        meteDeviceSate: '-',
        meteTime: null,
        meteOptionMap: null
      }
    },

    beforeDestroy() {
      clearInterval(this.meteTime);
      this.meteTime = null;
    },

   mounted() {
      //获取用户等级
      //let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      //let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
     let customerId = this.$route.params.customerId === undefined ?this.$commonFun.unCompileStr(localStorage.getItem('customerId') ) : this.$route.params.customerId;
      // if(authority == 'TENANT_ADMIN') {
      //   getDevicesInfo().then(response => {
      //     this.meteDeviceBoards(response.data);
      //   }).catch(error => {
      //     console.log("error", error);
      //   })
      // } else {
      //   getCustomerDevice(customerId).then(response => {
      //     this.meteDeviceBoards(response.data);
      //   }).catch(error => {
      //     console.log("error", error);
      //   })
      // }
     //设置设备列表
     let that = this;
     this.$MeteSoilCommon.getDeviceList(authority, customerId, function (deviceList) {//获取设备
       that.meteDeviceBoards(deviceList);
     })
    },

    methods: {
      /**
       * 设置设备列表
       * @param response
       */
      meteDeviceBoards(response) {
        // if(response.data.length === 0) return;
        // let that = this;
        // for(let i = 0; i < response.data.length; i++) {
        //   let meteJson = {};
        //   meteJson.id = response.data[i].id.id;
        //   meteJson.name = response.data[i].name;
        //   meteJson.type = response.data[i].id.entityType;
        //   this.$MeteSoilCommon.getLastConnectTime(meteJson.type, meteJson.id).then(time => {
        //     let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
        //     time < beforeTime ? meteJson.state = 'red' :  meteJson.state = 'green';
        //   })
        //   this.meteOption.push(meteJson);
        // }
        // if(this.meteOption.length > 0) {
        //   this.meteDevice = this.meteOption[0].id;
        //   //获取用户在后一次连接时间
        //   this.meteConnectTime();
        //   //根据选中的值获取设备数据
        //   this.meteDashInfo();
        // }

        if (response.data.length === 0) return;
        let promises = [];
        for(let i = 0; i < response.data.length; i++) {
          let meteJson = {
            id: response.data[i].id.id,
            name: response.data[i].name,
            type: response.data[i].id.entityType
          };

          let promise = this.$MeteSoilCommon.getLastConnectTime(meteJson.type, meteJson.id).then(time => {
            let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
            meteJson.state = time < beforeTime ? 'red' : 'green';
            return meteJson;
          });

          promises.push(promise);
        }

        Promise.all(promises).then(results => {
          this.meteOption = results;
          this.meteOptionMap = null;
          this.meteOptionMap = new Map(this.meteOption.map(item => [item.id, item]));
          if(this.meteOption.length > 0) {
            this.meteDeviceInfo(0, this.meteOption.length);
          }
        }).catch(error => {
          console.log("error", error);
        })
      },

      meteDeviceInfo(j, length) {
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.meteOption[j].id, function (deviceInfo) {
          that.meteOption[j].deviceInfo = deviceInfo;
          that.$MeteSoilCommon.getDeviceKeyList(deviceInfo, function (keyData) {
            that.meteDeviceOption(j, keyData);
            if(++j < length) {
              that.meteDeviceInfo(j, length) //使用递归获取每一个设备信息
            }
          })
        })
      },

      meteDeviceOption(j, keyData) {
        let strKey = '';
        let keyList = keyData.split(',');
        //筛选非墒情属性
        for(let i = 0; i < keyList.length; i++) {
          if(keyList[i].indexOf('soil') < 0 && keyList[i].indexOf('fxd_') < 0) {
            i == keyList.length - 1 ? strKey += keyList[i] : strKey += keyList[i] + ',';
          }
        }

        if(strKey != '') {
          this.meteOptionList.push(this.meteOption[j]);

          if(this.meteDevice == '') {
            this.meteDevice = this.meteOptionList[0].id;
            this.meteDeviceJson = this.meteOptionList[0].deviceInfo;
            // 获取用户在后一次连接时间
            this.meteConnectTime();
            // 根据选中的值获取设备数据
            this.meteDashInfo();
          }
        }
      },

      /**
       *  切换设备
       */
      meteRealChange(event) {
        this.meteDevice = event;
        clearInterval(this.meteTime);
        this.meteTime = null;
        for(let i = 0; i < this.meteOptionList.length; i++) {
          if(this.meteOptionList[i].id == this.meteDevice) {
            this.meteDeviceJson = this.meteOptionList[i].deviceInfo;
            //获取用户在后一次连接时间
            this.meteConnectTime();
            //根据选中的值获取设备数据
            this.meteDashInfo();
            break;
          }
        }
      },

      /**
       *  根据选中的值获取设备数据
       */
      meteDashInfo() {
        let that = this;
        // this.meteDeviceKeys(response.data.deviceId);
        this.$MeteSoilCommon.getDeviceKeyList(this.meteDeviceJson, function (keyData) {//获取设备id
          that.meteDeviceKeys(keyData);//获取设备key
        });

        this.meteTime = window.setInterval(()=>{
          setTimeout(() => {
            this.$MeteSoilCommon.getDeviceKeyList(this.meteDeviceJson, function (keyData) {//每隔一分钟获取设备id
              that.meteDeviceKeys(keyData);//获取设备key
            });
          },0)
        }, 1000 * 60);
      },

      /**
       * 获取设备key
       * @param deviceId
       */
      meteDeviceKeys(keyData) {
        // getDeviceKey(deviceId.entityType, deviceId.id).then(response=> {
        //   let deviceKey = '';
        //   let pattern = /^[A-Za-z0-9.-]+$/;
        //   for (let i = 0; i <= response.data.length - 1; i++) {
        //     if (pattern.test(response.data[i])) {
        //       i === response.data.length - 1 ? deviceKey += response.data[i] : deviceKey += response.data[i] + ','
        //     }
        //   }
        //   this.meteDeviceValues(deviceId, deviceKey);
        // }).catch(error => {
        //   console.log("error",error);
        // })

        let keyList = keyData.split(',');
        let strKey = '';
        //筛选非墒情属性
        for(let i = 0; i < keyList.length; i++) {
          if(keyList[i].indexOf('soil') < 0 && keyList[i].indexOf('fxd_') < 0) {
            i == keyList.length - 1 ? strKey += keyList[i] : strKey += keyList[i] + ','
          }
        }
        //获取设备value
        if(strKey != '') {
          this.meteDeviceValues(strKey);
        } else {
          this.meteDataList = [];
        }
      },

      /**
       * 获取设备value
       * @param deviceId
       * @param deviceKey
       */
      meteDeviceValues(strKey) {
        let meteResponse = [];
        getDeviceValue(this.meteDeviceJson.entityType, this.meteDeviceJson.id, strKey).then(response => {
          for (let obj in response.data) {
            for (let i = 0; i < response.data[obj].length; i++) {
              let meteValue = {};
              meteValue.name = obj;
              meteValue.ts = response.data[obj][i].ts;
              meteValue.value = parseFloat(response.data[obj][i].value);
              meteResponse.push(meteValue);
            }
          }
          meteResponse.sort(function (a, b) {
            return b.ts < a.ts ? -1 : 1
          });
          this.meteDataList = [];
          for (let i = 0; i < meteResponse.length; i++) {
            let meteValue = {};
            meteValue.ts = this.$commonFun.dateFormat(meteResponse[i].ts);
            meteValue.name = this.$t(meteResponse[i].name).split(',')[0];
            meteValue.value =  this.$t(meteResponse[i].name).split(',')[1] === undefined ?
              meteResponse[i].value : meteResponse[i].value + this.$t(meteResponse[i].name).split(',')[1];
            this.meteDataList.push(meteValue);
          }
        }).catch(error => {
          console.log("error",error)
        })
      },

      /**
       * 判断是否离线
       */
      meteConnectTime() {
        let option = this.meteOptionMap.get(this.meteDevice);
        if (option) {
          this.meteDeviceSate = option.state === 'red' ? '离线' : '在线';
        } else {
          // 如果没有找到对应的 id，设置默认值
          this.meteDeviceSate = '离线';
        }
      }
    }
  }
</script>

<style lang="less">
  @import "../less/MeteRealData";
</style>

<style>
  .meteReal-data-content::-webkit-scrollbar {
    display: none;
  }

  .red-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    margin-right: 5px;
  }

  .green-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/MeteRealData.vue